module.exports = __webpack_public_path__ + "7759775557c0e73aad067ef70741b157.ttf";